import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import {
  FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton,
} from "react-share";
import styles from "./sharedButton.module.scss";

function SharedButtons(props:any) {
  const router = useRouter();
  const url = `https://partsavatar.ca${router.asPath}`;
  const { t } = useTranslation("common");

  return (
    <div className={styles.main_div}>
      <span>
        {" "}
        {`${t("Share Post")}:`}
      </span>
      <FacebookShareButton
        url={url}
        quote={props.title}
        className={styles.shared_buttons}
      >
        <FacebookIcon size={35} round />
      </FacebookShareButton>
      <TwitterShareButton
        url={url}
        title={props.title}
        className={styles.shared_buttons}
      >
        <TwitterIcon size={35} round />
      </TwitterShareButton>

      <LinkedinShareButton
        url={url}
        title={props.title}
        className={styles.shared_buttons}
      >
        <LinkedinIcon size={35} round />
      </LinkedinShareButton>
    </div>
  );
}

export default SharedButtons;
